import script from "./EmailRenovacaoAntecipada.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailRenovacaoAntecipada.vue?vue&type=script&setup=true&lang=js"

import "./EmailRenovacaoAntecipada.vue?vue&type=style&index=0&id=71204f35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71204f35"]])

export default __exports__